import { currencyString } from '@calculations/decimal/format';
import { calculateFirstQtyQuoteTotal } from '@calculations/price/quote-total';
import { createSelector } from '@reduxjs/toolkit';
import { transformStoreStateToNestedQuoteLinesAndPrices } from '@ui/features/quote-builder/state/utilities/transform-quote';
import type { RootState } from '@ui/store';

import { selectQuoteBuilder } from '../selectors/quote-builder';

export const selectQuoteTotal = createSelector(
  [
    (state: RootState) => selectQuoteBuilder(state).quoteLines,
    (state: RootState) => selectQuoteBuilder(state).siteCode,
  ],
  (quoteLines, siteCode) => {
    if (!quoteLines || !siteCode) {
      return null;
    }

    const transformedQuoteLines =
      transformStoreStateToNestedQuoteLinesAndPrices(quoteLines);

    const { total } = calculateFirstQtyQuoteTotal({
      snapQuoteLinesWithPrices: transformedQuoteLines,
    });

    return currencyString(total);
  },
);
